export const user_info_keyname = "sid_user";
export const sport_period_config = "sport_period_config"
export const nlp_filter = "nlp_filter"
export const select_sport_code = "selectSport"
const search_filters = "search_filters"
const sort_fields = "sort_fields"


/**
 * cache userInfo against the port no.
 * @param {any} user
 */
const addUserInfo = (user: any) => {
  let userInfo = {};  
  localStorage.setItem(user_info_keyname, JSON.stringify(user));
};

/**
* @returns userInfo
*/
const getUserInfo = () => {
  const raw = JSON.parse(localStorage.getItem(user_info_keyname) || '{}') as any;
  if (raw && typeof raw === 'object' && !raw.token && raw.access_token) {
    return { ...raw, token: raw.access_token };
  }
  return raw;
};


/**
* @returns userInfo
*/
const isAuthenticated = () => {
  return localStorage.getItem(user_info_keyname) ? true : false;


};
/**
 * retrieves cookie from the browser 
 * @param {string} key
 * @returns cookie value
 */
function getCookie(key: any) {
  var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
}


/**
* cache userInfo against the port no.
* @param {any} period_config
*/
const addPeriodConfig = (period_config: any) => {
  localStorage.setItem(sport_period_config, JSON.stringify(period_config));
};

const getPeriodConfig = () => {
  return JSON.parse(localStorage.getItem(sport_period_config) || '{}');
};


const getNLPFilter = () => {
  return JSON.parse(localStorage.getItem(nlp_filter) || '{}');
};

const addNLPFilter = (nlp_filter_data: any) => {
  if(nlp_filter_data){
    localStorage.setItem(nlp_filter, JSON.stringify(nlp_filter_data));
  }
  else{
    localStorage.removeItem(nlp_filter)
  }
  
};

const getSearchFilter = () => {
  return JSON.parse(localStorage.getItem(search_filters) || '{}');
};

const addSearchFilter = (search_filters_data: any) => {
  if(search_filters_data){
    localStorage.setItem(search_filters, JSON.stringify(search_filters_data));
  }
  else{
    localStorage.removeItem(search_filters)
  }
  
};

const getSortFields = () => {
  return JSON.parse(localStorage.getItem(sort_fields) || '{}');
};

const addSortFields = (sort_fields_data: any) => {
  if(sort_fields_data){
    localStorage.setItem(sort_fields, JSON.stringify(sort_fields_data));
  }
  else{
    localStorage.removeItem(sort_fields)
  }
  
};

const setSelectedSport = (sport:any) =>{
  localStorage.setItem(select_sport_code,sport)
}

const getSelectedSport = (sport:any) =>{
  return localStorage.getItem(select_sport_code) || '';
}

/**
 * Parse JWT token and return payload
 * @returns parsed payload or null if invalid
 * @security JWT payloads use Base64URL encoding (- instead of +, _ instead of /).
 *           Using atob directly will fail on these characters. We must replace
 *           them before decoding to ensure robust handling of all valid tokens.
 */
const getTokenPayload = (): any | null => {
  const userInfo = getUserInfo();
  const token = userInfo?.access_token || userInfo?.token || '';
  if (!token) return null;

  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    // Convert Base64URL to standard Base64 before decoding
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    return payload;
  } catch (e) {
    return null;
  }
};

/**
 * Check if user has seat_overflow flag in JWT token
 * @returns true if seat_overflow is true or user is excess_user, false otherwise
 */
const hasSeatOverflow = (): boolean => {
  const payload = getTokenPayload();
  // Check both seat_overflow (global flag) and excess_user (user-specific flag)
  return payload?.seat_overflow === true || payload?.excess_user === true;
};

const localStorageService = {
  addUserInfo: addUserInfo,
  getUserInfo: getUserInfo,
  getCookie: getCookie,
  isAuthenticated: isAuthenticated,
  addPeriodConfig: addPeriodConfig,
  getPeriodConfig: getPeriodConfig,
  getNLPFilter: getNLPFilter,
  addNLPFilter: addNLPFilter,
  setSelectedSport:setSelectedSport,
  getSelectedSport:getSelectedSport,
  getSearchFilter:getSearchFilter,
  addSearchFilter:addSearchFilter,
  getSortFields:getSortFields,
  addSortFields:addSortFields,
  getTokenPayload,
  hasSeatOverflow,
};

export default localStorageService;
